const updates = [
  {
    date: '2026.07.30',
    title: '《星际穿越2》高清版本正式上线',
    type: 'new',
  },
  {
    date: '2026.07.29',
    title: '热门韩剧《月光之恋》全集更新完毕',
    type: 'update',
  },
  {
    date: '2026.07.28',
    title: '新增纪录片专区，百部高分纪录片入驻',
    type: 'new',
  },
  {
    date: '2026.07.27',
    title: '播放器升级至3.0版本，加载速度提升40%',
    type: 'tech',
  },
  {
    date: '2026.07.26',
    title: '暑期档热门动画电影合集上线',
    type: 'new',
  },
  {
    date: '2026.07.25',
    title: '《暗夜追踪》第四季同步海外更新',
    type: 'update',
  },
  {
    date: '2026.07.24',
    title: '经典港片修复版系列新增50部作品',
    type: 'new',
  },
  {
    date: '2026.07.23',
    title: '综艺《欢乐大本营》最新季全网首播',
    type: 'update',
  },
  {
    date: '2026.07.22',
    title: '服务器扩容完成，晚高峰观影更流畅',
    type: 'tech',
  },
];

const typeStyles: Record<string, { bg: string; dot: string; label: string }> = {
  new: { bg: 'bg-primary-500/10 border-primary-500/20', dot: 'bg-primary-500', label: '新上线' },
  update: { bg: 'bg-accent-500/10 border-accent-500/20', dot: 'bg-accent-400', label: '更新' },
  tech: { bg: 'bg-secondary-500/10 border-secondary-500/20', dot: 'bg-secondary-400', label: '系统' },
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-8 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-400 bg-primary-500/10 rounded-full mb-3">
            实时追踪
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            最新动态
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            每一天都有新内容，不错过任何精彩
          </p>
        </div>

        <div className="relative max-w-3xl mx-auto">
          <div className="absolute left-[19px] md:left-6 top-2 bottom-2 w-px bg-background-300/50"></div>

          <div className="space-y-1">
            {updates.map((item, idx) => {
              const style = typeStyles[item.type];
              return (
                <div key={idx} className="relative flex items-start gap-4 md:gap-6 pl-12 md:pl-16 py-3 group">
                  <div className={`absolute left-[15px] md:left-[19px] top-4 w-2.5 h-2.5 rounded-full ${style.dot} ring-4 ring-background-100`}></div>

                  <div className="flex-1 min-w-0">
                    <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3">
                      <span className="text-xs font-medium text-foreground-400 whitespace-nowrap font-label">
                        {item.date}
                      </span>
                      <span className={`inline-block w-fit px-2 py-0.5 text-[10px] font-medium rounded border ${style.bg} ${style.dot.replace('bg-', 'text-')} whitespace-nowrap`}>
                        {style.label}
                      </span>
                    </div>
                    <p className="mt-1 text-sm md:text-base text-foreground-700 group-hover:text-foreground-900 transition-colors leading-relaxed">
                      {item.title}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}